import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import styles from './index.scss';
import TextInput from '../text-input/index';
import Button from '../button/index';
import { CIRCLE_DANGER, CIRCLE_SUCCESS, ICON_ONLY } from '../button/variants';
import { Tick, Cross } from '../../helpers/icon-dictionary';
import withForm from '../with-form';
import messages from './messages';

const validate = fields => fields.groupname !== '';

class AddGroupForm extends Component {
    constructor(props) {
        super(props);
        this.handleOnClose = this.handleOnClose.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
    }

    handleOnSubmit = () => {
        const { addGroup, classroomDetail, fields } = this.props;
        addGroup(classroomDetail.classroomId, fields.groupname);
    }

    handleOnClose = () => {
        const { closeAddGroup } = this.props;
        closeAddGroup();
    }

    render() {
        const { addGroupInProgress, form, intl, modal, canSubmit } = this.props;
        const formTitle = intl.formatMessage(messages.title);
        const inputPlaceholder = intl.formatMessage(messages.inputPlaceholder);
        return (
            <div className={styles.addGroupComponent}>
                <h1 className={styles.header}>{formTitle}</h1>
                <TextInput
                    handleOnChange={form.handleTextInputOnChange}
                    name="groupname"
                    placeholder={inputPlaceholder} />
                <div className={styles.buttons}>
                    <Button
                        containerClassName={styles.cancelBtn}
                        disabled={addGroupInProgress}
                        handleOnClick={() => { modal.close(this.handleOnClose); }}
                        icon={Cross}
                        variant={CIRCLE_DANGER} />
                    <Button
                        containerClassName={styles.submitBtn}
                        disabled={!canSubmit || addGroupInProgress}
                        handleOnClick={() => { form.submit(this.handleOnSubmit); }}
                        icon={Tick}
                        variant={CIRCLE_SUCCESS} />
                </div>

                <Button
                    containerClassName={styles.buttonClose}
                    disabled={addGroupInProgress}
                    handleOnClick={() => { modal.close(this.handleOnClose); }}
                    icon={Cross}
                    variant={ICON_ONLY} />
            </div>
        );
    }
}

AddGroupForm.propTypes = {
    addGroup: PropTypes.func,
    addGroupInProgress: PropTypes.bool,
    classroomDetail: PropTypes.object,
    closeAddGroup: PropTypes.func,
    canSubmit: PropTypes.bool,
    fields: PropTypes.object,
    form: PropTypes.object,
    intl: intlShape.isRequired,
    modal: PropTypes.object
};

const StyledAddGroup = injectIntl(styleable(styles)(AddGroupForm));

export default withForm(StyledAddGroup, { validate });



// WEBPACK FOOTER //
// ./app/components/add-group/form.js